import styled from 'styled-components';
import { font } from 'styles/globals';
import { getColor } from 'styles/theme';
import type { Theme } from 'styles/theme';

export const NavigationMobileContent = styled.nav<{ theme: Theme }>`
  display: flex;
  align-items: center;
  padding: 16px 20px;
  height: 72px;
  position: relative;
  border-bottom: 1px solid ${getColor('borderPrimary')};
  justify-content: space-between;

  .logo {
    height: 24px;
    cursor: pointer;
  }

  .crypto-logo {
    height: 24px;
    width: 170px;
  }

  .well-logo {
    height: 24px;
    width: 178px;
    cursor: pointer;
  }
  
  .subscribe-cta-mobile {
    width: 138px;
    height: 39px;
    font-size: 16px;
    font-weight: 500;
    font-family: ${font.graphikCompact};
    background: #cf1417;
  }
`;

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
`;

export const RightSide = styled.div`
  display: flex;
  align-items: center;
`;

export default NavigationMobileContent;
